<script>
import RsNonConformityMixin from "@/mixins/RsNonConformityMixin";
import attachmentMixin from "@/mixins/attachmentMixin";
import {mapActions, mapGetters} from "vuex";
import {AlertService} from "@/services/AlertService";
import RsAttachment from "@/components/modules/rightship/RsAttachment.vue";
import RsImageComponent from "@/components/modules/rightship/RsImageComponent.vue";
import {permissionMixin} from "@/mixins/permissionMixins";
import CorrectiveActionAttachmentsHandler from "@/components/common/CorrectiveActionAttachmentsHandler.vue";
import attachment from "@/components/modules/accident-incident/Attachment.vue";
import ImageComp from "@/components/elements/ImageComp.vue";
import ImageSliderMixin from "@/mixins/ImageSliderMixin";
import {ReportService} from "@/services/ReportService";
import {FileService} from "@/services/FileService";
import ImageSlider from "@/components/common/ImageSlider.vue";
import AppLoading from "@/components/elements/AppLoading.vue";

export default {
  name: "NonConformityCorrectiveAction",
  components: {AppLoading, ImageSlider, ImageComp, CorrectiveActionAttachmentsHandler, RsAttachment,RsImageComponent},
  mixins:[RsNonConformityMixin,attachmentMixin, permissionMixin, ImageSliderMixin],
  data() {
    return {
      isGlobalSave: false,
      hasChangesInItems: false,
      nextItemKey: 0,
      existingAttachmentIdsToRemove: [],
      itemFolderMap: {
        'Publications': 'publications',
        'Safety Equipment': 'safety_equipment',
        'Fire Fighting': 'fire_fighting',
        'PPE': 'ppe',
        'Measurement Apparatus': 'measurement_apparatus',
        'Medical Equipment': 'medical_equipment',
        'Navigational Equipment': 'navigational_equipment',
        'Crew / Accommodation Equipment': 'crew_accommodation_equipment',
        'Chemicals': 'chemicals',
        'N/A': 'n_a',
      },
      imageMimes:[
        'image/jpg',
        'image/jpeg',
        'image/png',
      ],
      toolbar: [
        ['bold', 'italic', 'strike', 'underline'],
        [{
          'color': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
            "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
            "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
            "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
            "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"]
        }]
      ],
      addRsncBeforeAttachment:false,
      addRsncInstructionAttachment:false,
      addRsncRectifiedPhoto:false,
      addRsncRectifiedAttachments:false,
      addRsncItemPhotoAttachment:false,
      addAttachment:false,
      editStatus:false,
      itemsVessel: [],
      vesselItem: null,
      vesselSpec: null,
      attachmentHandlers: {},
      reportStatusInitial:[
          {
            id:1,
            name:'In Progress'
          },
          {
            id:2,
            name:'Ready to Close'
          },
          {
            id:3,
            name:'Closed'
          },
          {
            id:4,
            name:'Withdraw'
          },
      ]
    }
  },

  computed:{
    ...mapGetters(['rsncBeforeRecAttachments','rsncInstructionAttachments','rsncRectifiedPhotoAttachments','rsncRectifiedAttachments', 'rsReport', 'images',]),
    isCurrentItemDuplicate() {
      if (!this.vesselItem) {
        return false;
      }
      return this.itemsVessel.some(item => item.vesselItem === this.vesselItem);
    },
  },
  async created() {
    const params = {
      id: this.$route.params.id,
      rsncAttachmentTypeId: 6,
      rsnc: this.nonConformity.id
    }
    this.isLoading=true;
    params.isImage=1;
    await this.getCorrectiveActionAttachments(params);
  },
  mounted() {
    this.resetItemsList();
  },

  methods:{
    ...mapActions(['uploadRsAttachments','updateRsNonConformity', 'getCorrectiveActionAttachments', 'addCorrectiveActionAttachments', 'deleteCorrectiveActionAttachments']),
    async downloadAttachments(file_type='image'){
      swal.fire({
        title: 'Please wait',
      });
      swal.showLoading();
      let response=await ReportService.downloadCorrectiveActionAttachment({
        fileType:file_type,
        id:this.$route.params.id,
        rsncAttachmentTypeId:6,
        rsncId:this.nonConformity.id
      })
      if(response){
        let fileBlob=FileService.base64FileToBlob(response.file,response.mime_type);
        let url = window.URL.createObjectURL(fileBlob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', response.file_name);
        document.body.appendChild(link);
        link.click();
      }
      swal.close();
    },
    setAttachmentHandlerRef(el, key) {
      if (el) {
        this.attachmentHandlers[key] = el;
      } else {
        delete this.attachmentHandlers[key];
      }
    },
    async downloadImage(attachment){
      swal.fire({
        title: 'Please wait',
      });
      swal.showLoading();
      const response = await ReportService.generateCorrectiveActionAttachment({id:attachment.id});
      if (response) {
        await FileService.downloadDocument(response,attachment)
        swal.close();
      }
    },
    handleCancelClick() {
      this.setNonConformityEdit(false);
      this.resetItemsList();
      this.existingAttachmentIdsToRemove = [];
    },
    handleEditClick() {
      this.setNonConformityEdit(true);
      this.resetItemsList();
      this.existingAttachmentIdsToRemove = [];
    },
    resetItemsList() {
      this.vesselItem = null;
      this.vesselSpec = null;
      this.attachmentHandlers = {};
      this.nextItemKey = 0;
      this.hasChangesInItems = false;
      this.isGlobalSave = false;

      if (this.nonConformity.corrective_action?.vessel_supplied_items) {
        this.itemsVessel = this.nonConformity.corrective_action.vessel_supplied_items.map(item => {
          const key = item.id ? `db_${item.id}` : `new_${this.nextItemKey++}`;
          const initialAttachments = this.getFilepondAttachmentsForItem(item);

          return {
            ...item,
            _localKey: key,
            _initialAttachments: initialAttachments,
            showUploader: false,
            file_unique_ids: [],
            files_to_remove_ids: [],
            initial_file_ids: []
          };
        });
        this.nextItemKey = this.itemsVessel.length;
      } else {
        this.itemsVessel = [];
        this.nextItemKey = 0;
      }
    },
    getRawAttachmentsForItem(item) {
      if (!item || !item.vesselItem || !this.itemFolderMap[item.vesselItem]) {
        return [];
      }

      const itemFolder = this.itemFolderMap[item.vesselItem];

      const searchPath = `/item_supplied/${itemFolder}/`;

      return this.images.filter(image => {
        return image.path && image.path.includes(searchPath);
      });
    },

    getFilepondAttachmentsForItem(item) {
      const rawImages = this.getRawAttachmentsForItem(item);

      return rawImages.map(image => {
        return {
          source : image.path,
          options : {
            type : 'local',
            metadata : {
              id : image.id,
              thumbnail : image.thumbnail,
              file_size : image.file_size,
              created_at : image.created_at
            }
          }
        }
      });
    },
    async deleteAllAttachments(idsToDelete) {
      if (idsToDelete.length === 0) {
        return;
      }
      await this.deleteCorrectiveActionAttachments(idsToDelete);
    },
    setCorrectiveActionOption() {
      if(!this.nonConformityField.corrective_action.is_corrective_action_effective){
        this.nonConformityField.corrective_action.is_corrective_action_verified=0;
        this.nonConformityField.corrective_action.is_corrective_action_verified_date=null;
        this.nonConformityField.corrective_action.is_corrective_action_confirmed=0;
        this.nonConformityField.corrective_action.is_corrective_action_confirmed_date=null;
      }
    },
    async addItemToList(){
      if (!this.vesselItem) {
        return;
      }
      if (this.isCurrentItemDuplicate) {
        AlertService.warningAlert('This item is already in the list.', 'DUPLICATE ITEM');
        return;
      }
      this.itemsVessel.push({
        _localKey: `new_${this.nextItemKey++}`,
        vesselItem: this.vesselItem,
        vesselSpec: this.vesselSpec,
        _initialAttachments: [],
        showUploader: false,
        file_unique_ids: [],
        files_to_remove_ids: [],
        initial_file_ids: []
      });

      this.hasChangesInItems = true;
      this.vesselItem = null;
      this.vesselSpec = null;
    },
    addAttachmentIdsToRemove(attachmentIds) {
      if (!attachmentIds || attachmentIds.length === 0) {
        return;
      }

      const updatedIds = new Set([
        ...this.existingAttachmentIdsToRemove,
        ...attachmentIds
      ]);

      this.existingAttachmentIdsToRemove = Array.from(updatedIds);
    },
    removeItem(index) {
      const itemToRemove = this.itemsVessel[index];

      if (itemToRemove) {
        const attachments = this.getRawAttachmentsForItem(itemToRemove);
        const attachmentIdsToDelete = attachments.map(attachment => attachment.id);

        this.addAttachmentIdsToRemove(attachmentIdsToDelete);

        delete this.attachmentHandlers[itemToRemove._localKey];
      }

      this.itemsVessel.splice(index, 1);
      this.hasChangesInItems = true;
    },
    handleFileProcessed(itemIndex, file) {
      const item = this.itemsVessel[itemIndex];
      if (item && file.serverId) {
        const updatedIds = new Set(item.file_unique_ids);
        updatedIds.add(file.serverId);
        item.file_unique_ids = Array.from(updatedIds);
        this.hasChangesInItems = true;
      }
    },
    handleFileRemoved(itemIndex, file) {
      const item = this.itemsVessel[itemIndex];
      if (!item) return;

      const metadata = file.getMetadata();

      if (metadata && metadata.id) {
        const ids = new Set(this.existingAttachmentIdsToRemove);
        ids.add(metadata.id);
        this.existingAttachmentIdsToRemove = Array.from(ids);
        this.hasChangesInItems = true;
      }

      if (file.serverId) {
        const updatedIdsToRemove = new Set(item.files_to_remove_ids);
        updatedIdsToRemove.add(file.serverId);
        item.files_to_remove_ids = Array.from(updatedIdsToRemove);
      }
    },
    async saveItemsList(isFile = true, isComponentSave) {
      this.itemsVessel.forEach(item => {
        if (item.files_to_remove_ids && item.files_to_remove_ids.length > 0) {
          item.file_unique_ids = item.file_unique_ids.filter(
            id => !item.files_to_remove_ids.includes(id)
          );
          item.files_to_remove_ids = [];
        }
      });

      const attachmentRefsMap = this.attachmentHandlers;
      const fileMessage = 'Images';

      if (Object.values(attachmentRefsMap).some(ref => ref && ref.isProcessingFiles())) {
        return AlertService.warningAlert(`Please wait for the ${fileMessage} to finish processing`, 'ATTACHMENTS PROCESSING');
      }

      if (Object.values(attachmentRefsMap).some(ref => ref && ref.filesHasError())) {
        return;
      }

      if (isComponentSave && this.hasChangesInItems) {
        const verify = await swal.fire({
          icon: 'question',
          title: 'SAVE ITEM LIST',
          html: `Are you sure you want to save these changes to the items list?`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showCancelButton: true,
          cancelButtonText: 'DISREGARD',
          confirmButtonText: 'SAVE',
          confirmButtonColor: '#28a745',
          cancelButtonColor: '#dc3545'
        });

        if (!verify.isConfirmed) {
          this.resetItemsList();
          this.existingAttachmentIdsToRemove = [];
          return false;
        }
      }

      if (this.isGlobalSave && this.hasChangesInItems) {
        const verify = await swal.fire({
          icon: 'warning',
          title: 'UNSAVED ITEM LIST',
          html: "There's unsave changes in <br><strong>Items Supplied to the Vessel</strong><br><br>Do you want to save the changes?",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showCancelButton: true,
          cancelButtonText: 'DISREGARD',
          confirmButtonText: 'SAVE',
          confirmButtonColor: '#28a745',
          cancelButtonColor: '#dc3545'
        });

        if (!verify.isConfirmed) {
          this.resetItemsList();
          this.existingAttachmentIdsToRemove = [];
          return false;
        }

      }

      swal.fire({
        title: 'Please wait...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      });
      swal.showLoading();

      this.isLoading = true;

      if (!this.nonConformityField.corrective_action) {
        this.nonConformityField.corrective_action = {};
      }
      this.nonConformityField.corrective_action.itemsVessel = [...this.itemsVessel];

      try {
        await this.deleteAllAttachments(this.existingAttachmentIdsToRemove);

        const formData = new FormData();
        let hasNewAttachments = false;

        formData.append('id', this.$route.params.id);
        formData.append('rsncAttachmentTypeId', 6);
        formData.append('rsncId', this.nonConformity.id);

        for (const [index, item] of this.itemsVessel.entries()) {
          const attachmentHandler = attachmentRefsMap[item._localKey];
          if (!attachmentHandler) continue;

          const filesForThisItem = item.file_unique_ids || [];

          formData.append(`items[${index}][vesselItem]`, item.vesselItem);
          formData.append(`items[${index}][vesselSpec]`, item.vesselSpec);

          if (filesForThisItem.length > 0) {
            hasNewAttachments = true;
            filesForThisItem.forEach(fileId => {
              formData.append(`items[${index}][file_unique_ids][]`, fileId);
            });
          }
          attachmentHandler.resetValues();
        }

        if (hasNewAttachments) {
          await this.addCorrectiveActionAttachments(formData);
        }

        const itemUpdatePayload = {
          id: this.nonConformityField.id,
          corrective_action: {
            itemsVessel: this.nonConformityField.corrective_action.itemsVessel
          }
        };
        const response = await this.updateRsNonConformity(itemUpdatePayload);

        if (response) {
          AlertService.successAlert('Items list updated successfully', 'UPDATE SUCCESSFUL');
        }

        const params = {
          id: this.$route.params.id,
          rsncAttachmentTypeId: 6,
          rsnc: this.nonConformity.id,
          isImage: 1
        };
        await this.getCorrectiveActionAttachments(params);

        this.existingAttachmentIdsToRemove = [];
        this.resetItemsList();
        this.hasChangesInItems = false;
        swal.close();
        return true;

      } catch (error) {
        console.error("Error saving items list:", error);
        swal.close();
        AlertService.errorAlert("Failed to save items list.");
        this.resetItemsList();
        this.existingAttachmentIdsToRemove = [];
        this.hasChangesInItems = false;
        return false;
      } finally {
        this.isLoading = false;
      }

    },
    async addRsncCorrectiveActionAttachments(type,buttonState='addRsncBeforeAttachment'){
      let attachmentField='';
      let subMessage = '';
      switch(type){
        case 2:
          attachmentField='rsncBeforeAttachment'
          subMessage = 'File for Attached Photo before rectified has been Successfully added'
              break;
        case 3:
          attachmentField='rsncInstructionAttachment'
          subMessage = 'File for Attached any other instruction has been Successfully added'
              break;
        case 4:
          attachmentField='rsncRectifiedPhoto'
          subMessage = 'File for Attached rectified photos has been Successfully added'
              break;
        case 5:
          attachmentField='rsncRectifiedAttachments'
          subMessage = 'File for Attached rectified document/report has been Successfully added'
              break;
        default:
          attachmentField='rsncBeforeAttachment'
          subMessage = 'File for Attached Photo before rectified has been Successfully added'
            break;
      }
      let files= this.$refs[attachmentField].files;
      const formData=new FormData();
      if(files.length > 0) {
        Array.prototype.forEach.call(files,file=>{
          formData.append('attachments[]',file)
        })
        formData.append('id', this.$route.params.id)
        formData.append('type[id]', this.nonConformity.id)
        formData.append('type[type_id]', type)
        const response = await this.uploadRsAttachments(formData);
        if(response){
          AlertService.successAlert(subMessage,'FILE UPLOADING', 3000)
          await this.getRsAttachment(type,this.nonConformity,'id')
          this.$refs[attachmentField].value=null;
          this[buttonState] = false;
        }
      }
    },

    async deleteCorrectiveAttachment(event) {
      const response = await this.deleteFileRs(event.attachment, event.type)
      if(response) {
        AlertService.successAlert('Attachment Deleted Successfully','Delete Corrective Action Attachment')
        await this.getRsAttachment(event.type,this.nonConformity,'id')
      }
    },

    editReportStatus() {
      this.editStatus = true;
      this.nonConformityField=Object.assign({},this.nonConformity)
      this.currentStatus=this.nonConformityField?.report_status_id ?? null
    },

    cancelEditReportStatus() {
      this.editStatus = false;
      this.resetNonConformity()
    },

    async saveStatus() {
      let currStatusName = this.currentStatus ? this.reportStatusInitial.filter(stat => stat.id === this.currentStatus)[0]?.name : null;
      const changeReportStatusName = this.reportStatusInitial.filter(stat => stat.id === this.nonConformityField.report_status_id)[0].name;
      currStatusName = !currStatusName ? '' : currStatusName;
      const verify = swal.fire({
        icon: 'question',
        title: 'CHANGE REPORT STATUS',
        html: `CHANGING <strong> ${currStatusName} </strong> STATUS TO <strong> ${changeReportStatusName} </strong> STATUS `,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: true,
        cancelButtonText: 'CANCEL',
        confirmButtonText: 'PROCEED',
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#dc3545'
      }).then(result => {
        return result;
      })

      if ((await verify).isConfirmed) {
        const response = await this.updateRsNonConformity(this.nonConformityField);
        if (response) {
          this.editStatus=false;
          AlertService.successAlert('RS Non-Conformity updated successfully', 'UPDATE RS NON-CONFORMITY REPORT STATUS')
          this.resetNonConformity();
        }
      }
    },
  },

}
</script>

<template>
  <form @submit.prevent="confirmUpdateRsNonConformity">
    <div class="row">
      <div class="col-12 text-right">
        <template v-if="editNonConformity">
          <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="handleCancelClick" v-if="editNonConformity">Cancel</button>
          <button class="e-btn e-btn-blue ml-2" type="submit">Save</button>
        </template>
        <template v-else>
          <button class="e-btn e-btn-green ml-2 px-3" type="button"
                  @click="handleEditClick"
                  v-if="isAllowed('rightship.main.risq-findings.main.corrective-action.edit') || user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')"
          >Edit Corrective Action</button>
        </template>
      </div>
    </div>
    <table class="w-100">
      <tr>
        <td style="width: 25%">Questioner Section</td>
        <td>
          {{nonConformity.rsn_question.parent.main_question}}
        </td>
      </tr>
      <tr>
        <td style="width: 25%">Question No.</td>
        <td>
          {{nonConformity.rsn_question.code}}
        </td>
      </tr>
      <tr>
        <td style="width: 25%">Question</td>
        <td>
          {{nonConformity.rsn_question.main_question}}
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <hr />
        </td>
      </tr>
      <tr>
        <td>
          Report Status
        </td>
        <td>
          <template v-if="editStatus">
            <div class="row align-content-center align-items-center">
              <div class="col-auto">
                <select class="form-control form-control-sm" v-model="nonConformityField.report_status_id">
                  <option v-if="nonConformityField.report_status_id === null" :value="null" disabled>NEW</option>
                  <template v-for="reportStatus in reportStatusInitial">
                    <option :value="reportStatus.id">{{reportStatus.name}}</option>
                  </template>
                </select>
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-success btn-xs mr-2" @click="saveStatus">
                  <font-awesome-icon icon="save" class="force-white-all" />
                  Save
                </button>
                <button type="button" class="btn btn-danger btn-xs" @click="cancelEditReportStatus">
                  <font-awesome-icon icon="ban" class="force-white-all" />
                  Cancel
                </button>
              </div>
            </div>
          </template>
          <template v-else>
            <button type="button" class="e-btn e-btn-xs px-5"
                    style="color: white"
                    :style="{
                      backgroundColor: nonConformity.report_status_id === 1 ? '#42b983' :
                                       nonConformity.report_status_id === 2 ? '#042453' :
                                       nonConformity.report_status_id === 3 ? '#4c4c4c' :
                                       nonConformity.report_status_id === 4 ? '#eda119' :
                                       '#056cb4'
                    }"
                    @click="editReportStatus"
                    :disabled="(isAllowed('rightship.main.risq-findings.main.corrective-action.edit') || user.id === rsReport.created_by_id || isElite()) === false"
            >
              {{nonConformity.report_status_id ? reportStatusInitial.filter(stat=>stat.id == nonConformity.report_status_id )[0].name : 'NEW'}}
            </button>
          </template>

        </td>
      </tr>
      <tr>
        <td colspan="100%">
          <hr>
        </td>
      </tr>
      <tr>
        <td>
          Attached Photo before rectified
        </td>
        <td>
          <template v-if="editNonConformity">
            <template v-if="!addRsncBeforeAttachment">
              <div class="mb-3" v-if="isAllowed('rightship.main.risq-findings.main.corrective-action.attachments.before-rectified.edit') || user.id === rsReport.created_by_id || isElite()">
                <button class="e-btn e-btn-green mr-3"
                        @click="addRsncBeforeAttachment=!addRsncBeforeAttachment"
                >
                  Add Attachment
                </button>
              </div>
            </template>
            <div v-else>
              <input type="file" class="w-75" @change="addRsncCorrectiveActionAttachments(2,'addRsncBeforeAttachment')"
                     ref="rsncBeforeAttachment" accept="image/*" multiple>
              <button class="e-btn e-btn-outlined-red" @click="addRsncBeforeAttachment=!addRsncBeforeAttachment">Cancel</button>
            </div>
          </template>
          <template v-else>
            <button class="e-btn e-btn-blue mb-2"
                    type="button"
                    :disabled="rsncBeforeRecAttachments.length === 0"
                    :class="rsncBeforeRecAttachments.length === 0 ? 'e-btn-blue-disabled' : ''"
                    v-if="isAllowed('rightship.main.risq-findings.main.corrective-action.attachments.before-rectified.download-all') || user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')"
                    @click="downloadAllRsnc(2,nonConformity.id,rsReport.vessel_id)"
            >
              Download All
            </button>
          </template>
          <div class="row">
            <div   v-if="rsncBeforeRecAttachments.length" class="col-lg-2 col-md-4 col-sm-12 mb-1 justify-content-center align-content-center"
                   v-for="attachment in rsncBeforeRecAttachments">
              <template v-if="attachment.loading">
                  <app-loading :message="'Preparing attachments'"></app-loading>
              </template>
              <template v-else>
              <rs-image-component :image-info="attachment"
                    :type="2"
                    @deleteEmitter="deleteCorrectiveAttachment"
                    view-permission="rightship.main.risq-findings.main.corrective-action.attachments.before-rectified.view"
                    download-permssion="rightship.main.risq-findings.main.corrective-action.attachments.before-rectified.view"
                    delete-permission="rightship.main.risq-findings.main.corrective-action.attachments.before-rectified.edit"
>
              </rs-image-component>
              </template>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="100%">
          <hr>
        </td>
      </tr>
      <tr>
        <td style="width: 25%">a) Root Cause</td>
        <td>{{nonConformity.root_cause_id ? nonConformity.root_cause.name.toUpperCase() : ''}}</td>
      </tr>
      <tr>
        <td style="width: 25%">b) Factor of Root Cause</td>
        <td>{{nonConformity.root_cause_sub_id ? nonConformity.root_cause_sub.name.toUpperCase() : ''}}</td>
      </tr>
      <tr>
        <td colspan="2">
          <hr />
        </td>
      </tr>
      <tr>
        <td style="width: 25%">Instruct to take Corrective Action</td>
        <td>
          <vue-editor  class="my-2" v-if="editNonConformity" :editor-toolbar="toolbar" v-model="nonConformityField.corrective_action.instruction"></vue-editor>
          <div v-else class="pre-wrap-txt textarea-display-card my-2" v-html="nonConformity.corrective_action.instruction"/>
        </td>
      </tr>
      <tr>
        <td colspan="100%">
          <hr>
        </td>
      </tr>
      <tr v-if="editNonConformity">
        <td style="width: 25%">Items</td>
        <div class="row">
          <div class="col-9 pr-0">
            <select class="form-control form-control-sm" style="font-size: 9pt;" v-model="vesselItem">
              <option :value="null" disabled>Select an Item</option>
              <option value="Publications">Publications</option>
              <option value="Safety Equipment">Safety Equipment</option>
              <option value="Fire Fighting">Fire Fighting</option>
              <option value="PPE">PPE</option>
              <option value="Measurement Apparatus">Measurement Apparatus</option>
              <option value="Medical Equipment">Medical Equipment</option>
              <option value="Navigational Equipment">Navigational Equipment</option>
              <option value="Crew / Accommodation Equipment">Crew / Accommodation Equipment</option>
              <option value="Chemicals">Chemicals</option>
              <option value="N/A">N/A</option>
            </select>
            <small v-if="editNonConformity && !vesselItem" class="text-danger font-weight-bold" style="font-style: italic">
              *Item is required
            </small>
            <small v-if="editNonConformity && isCurrentItemDuplicate" class="text-danger font-weight-bold" style="font-style: italic">
              *This item has already been added
            </small>
          </div>
          <div class="col-3 text-right pl-0">
            <button class="e-btn mr-1" @click="addItemToList" type="button"
                     style="width: 45%;"
                    :disabled="!vesselItem || isCurrentItemDuplicate"
                    :class="(!vesselItem || isCurrentItemDuplicate) ? 'e-btn-blue-gray' : 'e-btn-green'"
                    :style="{
                      cursor: (!vesselItem || isCurrentItemDuplicate) ? 'not-allowed' : 'pointer'
                    }">
              Add Item
            </button>
            <button class="e-btn w-50"
                    @click="saveItemsList(false, true)"
                    type="button"
                    :disabled="!hasChangesInItems || isCurrentItemDuplicate"
                    :class="!hasChangesInItems || isCurrentItemDuplicate ? 'e-btn-blue-gray' : 'e-btn-blue'"
                    :style="{ cursor: !hasChangesInItems || isCurrentItemDuplicate ? 'not-allowed' : 'pointer' }">
              Save List
            </button>
          </div>
        </div>
      </tr>
      <tr  v-if="editNonConformity">
        <td style="width: 25%">Specifications</td>
        <td>
          <div class="row mt-3">
            <div class="col-12">
              <textarea class="form-control" placeholder="Specifications of the item" style="font-size: 9pt;" v-model="vesselSpec"></textarea>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 25%">Items Supplied to the Vessel</td>
        <td v-if="editNonConformity">
          <hr>
          <small class="text-danger font-weight-bold" style="font-style: italic">NOTE: Please make sure to include all the items before clicking the "Save List" button.</small>
          <div class="row mt-3">
            <div class="col-12 col-md-6 mb-3" v-for="(data, index) in itemsVessel" :key="data._localKey">
              <div class="card h-100" style="position: relative;">
                <span class="font-weight-bold text-danger"
                      style="position: absolute; top: 10px; right: 15px; z-index: 10; font-size: 1.25rem; cursor: pointer; line-height: 1;"
                      @click="removeItem(index)">
                  X
                </span>
                <div class="card-header">
                  <strong class="text-uppercase" style="color: black; font-size: 16px;">{{data.vesselItem}}</strong>
                </div>
                <div class="card-body">
                  <strong style="color: black">Specification</strong>
                  <div class="mt-2" style="white-space: pre-wrap; min-height: 20px; overflow-wrap: break-word; color: black">
                    {{ data.vesselSpec || 'N/A' }}
                  </div>
                  <hr>
                  <strong style="color: black">Images</strong>
                  <div class="mt-2">
                    <corrective-action-attachments-handler
                      :ref="el => setAttachmentHandlerRef(el, data._localKey)"
                      :accepted-file-types="imageMimes"
                      :current-attachments="data._initialAttachments"
                      :max-height="150"
                      :hide-file-names="true"
                      @processfile="handleFileProcessed(index, $event)"
                      @file-removed="handleFileRemoved(index, $event)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td v-else>
          <button class="e-btn e-btn-blue mb-2"
                  type="button"
                  :disabled="images.length === 0"
                  :class="images.length === 0 ? 'e-btn-blue-disabled' : ''"
                  v-if="user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')"
                  @click="downloadAttachments('image')"
          >
            Download All
          </button>
          <div class="row mt-3">

            <div class="col-12 col-md-6 mb-3"
                 v-for="(data, index) in nonConformity.corrective_action.vessel_supplied_items"
                 :key="index">
              <div class="card h-100">
                <div class="card-header">
                  <strong class="text-uppercase" style="color: black; font-size: 16px;">{{data.vesselItem}}</strong>
                </div>
                <div class="card-body">
                  <strong style="color: black">Specification</strong>
                  <div class="mt-2" style="white-space: pre-wrap; min-height: 20px; overflow-wrap: break-word; color: black">
                    {{ data.vesselSpec || 'N/A' }}
                  </div>
                  <hr>
                  <strong style="color: black">Images</strong>
                  <div class="row mt-2">
                    <div v-if="getRawAttachmentsForItem(data).length === 0" class="col-12">
                      <small class="text-muted">No images attached for this item.</small>
                    </div>
                    <div v-for="(attachment, attachmentIndex) in getRawAttachmentsForItem(data)"
                         :key="attachment.id"
                         class="col-lg-4 col-md-6 col-sm-6 mb-3">
                      <image-comp
                        :imageInfo="attachment"
                        :can-delete="false"
                        @initDownload="downloadImage"
                        @initView="viewImage(attachmentIndex, JSON.parse(JSON.stringify(getRawAttachmentsForItem(data))), {
                'path'      : 'thumbnail',
                'caption'   : 'attachment_name',
              })"
                        view-permission="rightship.main.risq-findings.main.corrective-action.attachments.other-instruction.view"
                        download-permssion="rightship.main.risq-findings.main.corrective-action.attachments.other-instruction.view"
                      ></image-comp>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="100%">
          <hr>
        </td>
      </tr>
      <tr>
        <td style="width: 25%">Attached any other instruction</td>
        <td>
          <template v-if="editNonConformity">
            <template v-if="!addRsncInstructionAttachment">
              <div class="mb-2" v-if="isAllowed('rightship.main.risq-findings.main.corrective-action.attachments.other-instruction.edit') || user.id === rsReport.created_by_id || isElite()">
                <button class="e-btn e-btn-green mr-3"
                        @click="addRsncInstructionAttachment=!addRsncInstructionAttachment"
                >
                  Add Attachment
                </button>

              </div>
            </template>
            <div v-else>
              <input type="file" class="w-75" @change="addRsncCorrectiveActionAttachments(3,'addRsncInstructionAttachment')" ref="rsncInstructionAttachment"  multiple>
              <button class="e-btn e-btn-outlined-red" @click="addRsncInstructionAttachment=!addRsncInstructionAttachment">Cancel</button>
            </div>
          </template>
          <template v-else>
            <button class="e-btn e-btn-blue"
                    type="button"
                    v-if="isAllowed('rightship.main.risq-findings.main.corrective-action.attachments.other-instruction.download-all') || user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')"
                    :disabled="rsncInstructionAttachments.length === 0"
                    :class="rsncInstructionAttachments.length === 0 ? 'e-btn-blue-disabled' : ''"
                    @click="downloadAllRsnc(3,nonConformity.id,rsReport.vessel_id)"
            >
              Download All
            </button>
          </template>
          <rs-attachment v-if="rsncInstructionAttachments.length" :attachments="rsncInstructionAttachments"
                         style="height: 15vh;"
                         :type="3"
                         view-permission="rightship.main.risq-findings.main.corrective-action.attachments.other-instruction.view"
                         download-permssion="rightship.main.risq-findings.main.corrective-action.attachments.other-instruction.view"
                         delete-permission="rightship.main.risq-findings.main.corrective-action.attachments.other-instruction.edit"
                         @deleteEmitter="deleteCorrectiveAttachment"
          >
          </rs-attachment>
        </td>
      </tr>
      <tr>
        <td colspan="100%">
          <hr>
        </td>
      </tr>
      <tr>
        <td>Date of Instruction</td>
        <td>
          <input v-if="editNonConformity" type="date" class="form-control form-control-sm" v-model="nonConformityField.corrective_action.instruction_date">
          <span v-else>{{nonConformity.corrective_action.instruction_date | eliteDate}}</span>
        </td>
      </tr>
      <tr>
        <td>To be Done</td>
        <td>
          <input v-if="editNonConformity" type="date" class="form-control form-control-sm" v-model="nonConformityField.corrective_action.instruction_done_date">
          <span v-else>{{nonConformity.corrective_action.instruction_done_date | eliteDate}}</span>
        </td>
      </tr>
      <tr>
        <td>Instructed by (Person In Charge)</td>
        <td></td>
      </tr>
      <tr>
        <td colspan="2">
          <hr />
        </td>
      </tr>
      <tr>
        <td style="width: 25%">Action Taken</td>
        <td>
          <vue-editor  class="my-2" v-if="editNonConformity" :editor-toolbar="toolbar" v-model="nonConformityField.corrective_action.action_taken"></vue-editor>
          <div v-else class="pre-wrap-txt textarea-display-card my-2" v-html="nonConformity.corrective_action.action_taken"/>
        </td>
      </tr>
      <tr>
        <td>Date of Report</td>
        <td>
          <input v-if="editNonConformity" type="date" class="form-control form-control-sm" v-model="nonConformityField.corrective_action.action_taken_date" >
          <span v-else>{{nonConformity.corrective_action.action_taken_date | eliteDate}}</span>
        </td>
      </tr>
      <tr>
        <td>Reported by</td>
        <td>
          <input v-if="editNonConformity" type="text" class="form-control form-control-sm" v-model="nonConformityField.corrective_action.reported_by">
          <span v-else>{{nonConformity.corrective_action.reported_by}}</span>
        </td>
      </tr>
      <tr>
        <td colspan="100%">
          <hr>
        </td>
      </tr>
      <tr>
        <td style="width: 25%">Attached rectified photos</td>
        <td>
          <template v-if="editNonConformity">
            <template v-if="!addRsncRectifiedPhoto">
              <div class="mb-2" v-if="isAllowed('rightship.main.risq-findings.main.corrective-action.attachments.rectified-photos.edit') || user.id === rsReport.created_by_id || isElite()">
                <button class="e-btn e-btn-green mr-3"
                        @click="addRsncRectifiedPhoto=!addRsncRectifiedPhoto"
                >
                  Add Attachment
                </button>
              </div>
            </template>
            <div v-else>
              <input type="file" class="w-75" @change="addRsncCorrectiveActionAttachments(4,'addRsncRectifiedPhoto')" accept="image/*" ref="rsncRectifiedPhoto"  multiple>
              <button class="e-btn e-btn-outlined-red">Cancel</button>
            </div>
          </template>
          <template v-else>
            <button class="e-btn e-btn-blue"
                    type="button"
                    v-if="isAllowed('rightship.main.risq-findings.main.corrective-action.attachments.rectified-photos.download-all') || user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')"
                    :disabled="rsncRectifiedPhotoAttachments.length === 0"
                    :class="rsncRectifiedPhotoAttachments.length === 0 ? 'e-btn-blue-disabled' : ''"
                    @click="downloadAllRsnc(4,nonConformity.id,rsReport.vessel_id)"
            >
              Download All
            </button>
          </template>
          <div class="row">
            <div   v-if="rsncRectifiedPhotoAttachments.length" class="col-lg-2 col-md-4 col-sm-12 mb-1 justify-content-center align-content-center"
                   v-for="attachment in rsncRectifiedPhotoAttachments">
              <template v-if="attachment.loading">
                <app-loading :message="'Preparing attachments'"></app-loading>
              </template>
              <template v-else>
                <rs-image-component :image-info="attachment"
                                    :type="4"
                                    @deleteEmitter="deleteCorrectiveAttachment"
                                    view-permission="rightship.main.risq-findings.main.corrective-action.attachments.rectified-photos.view"
                                    download-permssion="rightship.main.risq-findings.main.corrective-action.attachments.rectified-photos.view"
                                    delete-permission="rightship.main.risq-findings.main.corrective-action.attachments.rectified-photos.edit"
                >
                </rs-image-component>
              </template>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="100%">
          <hr>
        </td>
      </tr>
      <tr>
        <td style="width: 25%">Attached rectified document/report</td>
        <td>
          <template v-if="editNonConformity">
            <template v-if="!addRsncRectifiedAttachments">
              <div class="mb-2" v-if="isAllowed('rightship.main.risq-findings.main.corrective-action.attachments.rectified-documents.edit') || user.id === rsReport.created_by_id || isElite()">
                <button class="e-btn e-btn-green mr-3"
                        @click="addRsncRectifiedAttachments=!addRsncRectifiedAttachments"
                >
                  Add Attachment
                </button>
              </div>
            </template>
            <div v-else>
              <input type="file" class="w-75" @change="addRsncCorrectiveActionAttachments(5,'addRsncRectifiedAttachments')" ref="rsncRectifiedAttachments"  multiple>
              <button class="e-btn e-btn-outlined-red">Cancel</button>
            </div>
          </template>
          <template v-else>
            <button class="e-btn e-btn-blue"
                    :disabled="rsncRectifiedAttachments.length === 0"
                    :class="rsncRectifiedAttachments.length === 0 ? 'e-btn-blue-disabled' : ''"
                    type="button"
                    v-if="isAllowed('rightship.main.risq-findings.main.corrective-action.attachments.rectified-documents.download-all') || user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')"
                    @click="downloadAllRsnc(5,nonConformity.id,rsReport.vessel_id)"
            >
              Download All
            </button>
          </template>
          <rs-attachment v-if="rsncRectifiedAttachments.length" :attachments="rsncRectifiedAttachments"
                         style="height: 15vh;"
                         :type="5"
                         view-permission="rightship.main.risq-findings.main.corrective-action.attachments.rectified-documents.view"
                         download-permssion="rightship.main.risq-findings.main.corrective-action.attachments.rectified-documents.view"
                         delete-permission="rightship.main.risq-findings.main.corrective-action.attachments.rectified-documents.edit"
                         @deleteEmitter="deleteCorrectiveAttachment"
          >
          </rs-attachment>
        </td>
      </tr>
      <tr>
        <td colspan="100%">
          <hr>
        </td>
      </tr>
      <tr>
        <td>Enclosures</td>
        <td>
          <template v-if="rsncRectifiedAttachments && rsncRectifiedAttachments.length">
            <ul>
              <li
                v-for="(data, index) in rsncRectifiedAttachments"
                :key="index"
                @click="!data.loading && viewRsDownloadFile(data, 5)"
                style="cursor: pointer"
              >
                <template v-if="data.loading">
                  <app-loading :message="'Preparing attachments'"></app-loading>
                </template>
                <template v-else>{{ data.enclosure_name }}</template>
              </li>
            </ul>
          </template>
          <template v-else>
            <span>No attachments available</span>
          </template>
        </td>
      </tr>
    </table>
    <hr />
    <table>
      <tr>
        <td colspan="2">
          Corrective action is effective to keep suitable level appropriate to the risk of problem encountered. (Case is completed and closed.)
        </td>
        <td colspan="2">
          <select v-if="editNonConformity" class="form-control form-control-sm mb-1" style="width: 150px;" @change="setCorrectiveActionOption" v-model="nonConformityField.corrective_action.is_corrective_action_effective">
            <option :value="1">Yes</option>
            <option :value="0">No</option>
          </select>
          <span v-else>{{nonConformity.corrective_action.is_corrective_action_effective ? 'YES' : 'NO'}}</span>
        </td>
      </tr>
      <tr v-if="nonConformity.corrective_action.is_corrective_action_effective">
        <td style="width: 25%">
          a) Verification of effectiveness for Corrective Action
        </td>
        <td style="width: 25%">
          <select v-if="editNonConformity" class="form-control form-control-sm mb-1" style="width: 150px;" v-model="nonConformityField.corrective_action.is_corrective_action_verified">
            <option :value="1">Yes</option>
            <option :value="0">No</option>
          </select>
          <span v-else>{{nonConformity.corrective_action.is_corrective_action_verified ? 'YES' : 'NO'}}</span>
        </td>
        <td style="width: 10%">Date of verification</td>
        <td>
          <input v-if="editNonConformity" type="date" class="form-control-sm form-control" style="width: 150px;" v-model="nonConformityField.corrective_action.is_corrective_action_verified_date">
          <span v-else>{{nonConformity.corrective_action.is_corrective_action_verified_date | eliteDate }}</span>
        </td>
      </tr>
      <tr v-if="nonConformity.corrective_action.is_corrective_action_effective">
        <td>
          b) Effectiveness for Corrective Actions has not been confirmed,
        </td>
        <td>
          <select v-if="editNonConformity" class="form-control form-control-sm mb-1" style="width: 150px;" v-model="nonConformityField.corrective_action.is_corrective_action_confirmed">
            <option :value="1">Yes</option>
            <option :value="0">No</option>
          </select>
          <span v-else>{{nonConformity.corrective_action.is_corrective_action_confirmed ? 'YES' : 'NO'}}</span>
        </td>
        <td>Date of verification</td>
        <td>
          <input v-if="editNonConformity" type="date" class="form-control-sm form-control" style="width: 150px;" v-model="nonConformityField.corrective_action.is_corrective_action_confirmed_date">
          <span v-else>{{nonConformity.corrective_action.is_corrective_action_confirmed_date | eliteDate}}</span>
        </td>
      </tr>
      <tr>
        <td>P.I.C. or Superintendent</td>
        <td></td>
      </tr>
    </table>
    <image-slider
      :selected-image-index="selectedImageIndex"
      :images="sliderImages"
      :visible="showSlider"
      @hideSlider="resetSlider()"
    >
    </image-slider>
  </form>
</template>

<style scoped>
table td {
  padding: 2px !important;
}

li:hover {
  color: #d3313c;
  font-weight: bold;
}
</style>
